<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('code')"
    @check-none="checkNone('code')"
    @set-selected-row="setSelectedRow($event, 'code')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as VAT_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'VatTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'slug',
          label: this.$t('Slug'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'slug'
        },
        {
          key: 'aliquot_perc',
          label: this.$t('Aliquot percentage'),
          tdClass: 'text-nowrap text-right',
          thClass: 'text-nowrap text-right',
          sortable: true,
          value: 'aliquot_perc'
        },
        {
          key: 'deduct_perc',
          label: this.$t('Deduct percentage'),
          tdClass: 'text-nowrap text-right',
          thClass: 'text-nowrap text-right',
          sortable: true,
          value: 'deduct_perc'
        },
        {
          key: 'description',
          label: this.$t('Description'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'description'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'aliquot_perc', 'deduct_perc', 'description'],
      fieldName: 'code'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: VAT_TYPES.GENERIC.vat.vat.LIST.GETTERS.selectAll,
      selectedList: VAT_TYPES.GENERIC.vat.vat.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('vat_vat_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: VAT_TYPES.GENERIC.vat.vat.LIST.MUTATIONS.setList,
      setSelectedList:
        VAT_TYPES.GENERIC.vat.vat.LIST.MUTATIONS.setSelectedList,
      setSelectAll: VAT_TYPES.GENERIC.vat.vat.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...VAT_TYPES.GENERIC.vat.vat.LIST.ACTIONS
    })
  }
}
</script>
